import React, { useEffect, useState } from "react";
import styles from "./ViewPlaceholder.module.css";
import { useNavigate } from "react-router-dom";

function Settings() {
    const navigate = useNavigate();
    const [language, setLanguage] = useState("en");
    const [theme, setTheme] = useState("light");
    const [notifications, setNotifications] = useState(true);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        // Load saved preferences (if any)
        try {
            const raw = localStorage.getItem("preferences");
            if (raw) {
                const prefs = JSON.parse(raw);
                if (prefs.language) setLanguage(prefs.language);
                if (prefs.theme) setTheme(prefs.theme);
                if (typeof prefs.notifications === "boolean") setNotifications(prefs.notifications);
            }
        } catch (e) {
            // ignore parse errors
            console.warn("Failed to load preferences", e);
        }
    }, []);

    const handleSave = (e) => {
        e.preventDefault();
        const prefs = { language, theme, notifications };
        try {
            localStorage.setItem("preferences", JSON.stringify(prefs));
            setSaved(true);
            setTimeout(() => setSaved(false), 1500);
        } catch (err) {
            console.error("Failed to save preferences", err);
        }
    };

    return (
        <div className={styles.placeholderContainer}>
            {/* Responsive header with back button */}
            <div className={styles.viewHeader}>
                <button
                    type="button"
                    className={styles.backBtn}
                    aria-label="Back to home"
                    onClick={() => navigate('/home')}
                >
                    <span aria-hidden>←</span>
                    <span className={styles.backLabel}>Home</span>
                </button>
            </div>
            <h1>Settings</h1>
            <p>Adjust your preferences below. These are placeholders for now.</p>

            <form className={styles.form} onSubmit={handleSave}>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor="language">Language</label>
                    <select
                        id="language"
                        className={styles.select}
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                    >
                        <option value="en">English</option>
                        <option value="ar">Arabic</option>
                        <option value="fr">Français</option>
                        <option value="es">Español</option>
                    </select>
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor="notifications">Notifications</label>
                    <input
                        id="notifications"
                        type="checkbox"
                        checked={notifications}
                        onChange={(e) => setNotifications(e.target.checked)}
                    />
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.5rem" }}>
                    <button type="submit" className={styles.button}>Save Preferences</button>
                    {saved && <span style={{ marginLeft: "0.75rem" }}>Saved</span>}
                </div>
            </form>
        </div>
    );
}

export default Settings;
